<template>
    <v-list-item>
        <v-list-item-avatar color="primary" size="28">
            <span class="white--text">{{ nameFirstChar }}</span>
        </v-list-item-avatar>
        <v-list-item-title>{{ profile }}</v-list-item-title>
    </v-list-item>
</template>

<script>
    import {mapState, mapGetters} from "vuex";

    export default {
        name: "Avatar",

        computed: {
            ...mapState([
                "profile"
            ]),

            ...mapGetters([
                "nameFirstChar"
            ])
        }
    }
</script>

<style scoped>

</style>
